export const getPremiumPlanData = (activePlan) => {
  if (!activePlan) return null;

  return {
    title: activePlan?.plan?.name,
    status: activePlan?.status_text,
    messageCount: `${activePlan?.contact_view_limit ?? 0} out of ${
      activePlan?.total_contact_limit ?? 0
    }`,
    infoMessage: activePlan?.balance
      ? `Ends in ${activePlan.balance} days`
      : "No expiry date",
    oldPrice: Number(activePlan?.plan?.amount) || 0,
    currentPrice: Number(activePlan?.plan?.discount_amount) || 0,
    planFeature: Array.isArray(activePlan?.plan?.plan_feature_ids)
      ? activePlan.plan.plan_feature_ids.map((f) => String(f))
      : [],
    description: activePlan?.plan?.description || "",
    plan_id: activePlan?.plan?.id,
  };
};

export const getFreePlanData = (activePlan) => {
  if (!activePlan || Object.keys(activePlan).length === 0) {
    return {
      title: "No active plan",
      messageCount: "0 out of 0",
      infoMessage: "Unlock more features with a Premium Plan! Subscribe now",
      planFeature: [],
      description: null,
    };
  }

  return {
    title: activePlan?.plan?.name,
    messageCount: `${activePlan?.contact_view_limit ?? 0} out of ${
      activePlan?.total_contact_view_limit ?? 0
    }`,
    infoMessage: "Unlock more features with a Premium Plan! Subscribe now",
    planFeature: Array.isArray(activePlan?.plan?.plan_feature_ids)
      ? activePlan.plan.plan_feature_ids.map((f) => String(f))
      : [],
    description:
      "You're currently using the basic free plan, which comes with limited access to profiles and features. Upgrade to a premium plan to enjoy",
  };
};

export const getFormattedPlans = (subscriptionPlans = [], allFeatures = []) => {
  return subscriptionPlans.map((plan) => {
    const featureIds = plan.plan_feature_ids || [];

    return {
      key: plan.id,
      plan_id: plan.id,
      title: plan.name,
      tagText: plan.badge,
      price: Number(plan.amount),
      offerPrice: Number(plan.discount_amount || 0),
      oldPrice: Number(plan.amount),
      planValidity: plan.duration,
      views: plan.contact_view_limit,
      plan_feature_ids: featureIds,
      is_popular: plan.badge === "Most Popular",
      features: featureIds
        .map((id) => allFeatures.find((f) => f.id === id))
        .filter(Boolean),
    };
  });
};

export const getFormattedPersonalizedPlans = (plans = [], allFeatures = []) => {
  return plans.map((plan) => {
    // const featureIds = plan.plan_feature_ids || [];
    const featureIds = plan.plan_feature_ids || [];

    return {
      key: plan.id,
      plan_id: plan.id,
      title: plan.name,
      tagText: plan.badge,
      price: plan.amount,
      offerPrice: Number(plan.discount_amount || 0),
      oldPrice: Number(plan.amount),
      views: plan.contact_view_limit,
      planValidity: plan.duration,
      is_popular: plan.badge === "Most Popular",
      contact_view_limit: plan.contact_view_limit,

      features: featureIds
        .map((id) => allFeatures.find((f) => f.id === id)?.name)
        .filter(Boolean),
    };
  });
};
